// extracted by mini-css-extract-plugin
module.exports = {"el":"HomeBody-module--el--1Qz55","body":"HomeBody-module--body--3Q5Q9"};